<template>
  <v-tooltip bottom content-class="tooltip-bottom" nudge-bottom="5" open-delay="200" :disabled="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on, attrs }">
      <button
        class="theme-pill"
        :class="{ 'is-dark': isDark }"
        @click="toggle"
        v-bind="attrs"
        v-on="on"
        aria-label="Toggle dark mode"
      >
        <div class="theme-pill-thumb">
          <v-icon size="12" :color="isDark ? '#f1c40f' : '#64748b'">
            {{ isDark ? 'mdi-weather-night' : 'mdi-weather-sunny' }}
          </v-icon>
        </div>
      </button>
    </template>
    <span>{{ isDark ? 'Switch to Light Mode' : 'Switch to Dark Mode' }}</span>
  </v-tooltip>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'ThemeToggle',

  computed: {
    ...mapState('theme', ['isDark']),
  },

  methods: {
    ...mapMutations('theme', ['toggleTheme']),

    toggle() {
      this.toggleTheme();
      // Sync with Vuetify
      if (this.$vuetify) {
        this.$vuetify.theme.dark = this.$store.state.theme.isDark;
      }
    },
  },
};
</script>

<style scoped>
.theme-pill {
  width: 52px;
  height: 28px;
  background: var(--bg-primary, #f1f5f9);
  border: 1px solid var(--border-color, rgba(0,0,0,0.07));
  border-radius: 14px;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 3px;
  transition: all 0.25s ease;
  flex-shrink: 0;
  outline: none;
}

.theme-pill:hover {
  border-color: #F26522;
  box-shadow: 0 0 0 2px rgba(242,101,34,0.15);
}

.theme-pill-thumb {
  width: 22px;
  height: 22px;
  background: var(--card-bg, #fff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(0,0,0,0.14);
  transition: transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.theme-pill.is-dark .theme-pill-thumb {
  transform: translateX(24px);
}
</style>
